import { Component, OnInit, ViewChild, AfterViewInit, HostListener } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { AlertService } from '../../_alert';
import { Router } from "@angular/router";
import { ActivatedRoute } from '@angular/router';

@Component({
    selector: 'app-careers',
    templateUrl: './careers.component.html',
    styleUrls: ['./careers.component.css']
})
export class CareersDetailsComponent implements OnInit {
    isMobile = true;
    isDesktop = true;

    @HostListener("window:resize", [])
    onResize() {
        var width = window.innerWidth;
        if (width < 768) {
            this.isMobile = true;
            this.isDesktop = false;
        } else {
            this.isMobile = false;
            this.isDesktop = true;
        }
    }

	model: any = {};
	mobNumberPattern = "^((\\+91-?)|0)?[0-9]{10}$";
	// Meta Title

    id : string;
    filedata:any;
    fd = new FormData();
  
	constructor(
		private formBuilder: FormBuilder,
		private http: HttpClient,
		private titleService: Title,
		private metaTagService: Meta,
		private alertService: AlertService,
		private router: Router,   
        private route: ActivatedRoute,
	) { this.id = this.route.snapshot.params['id'];  }

	apiurl = environment.apiUrl;
	blogUrl = environment.blogUrl
	
	careerForm:any = FormGroup;
    submitted = false;
	
	isDisabled = false;
	errorcallback = false;
	successcallback = false;
	country_code = '';
	showLoader = false;

	filename='';

    public careerJobsList: any = '';
    public activeJobsList: any = '';
    public jobdescrption: any ='';
    
	countries: any = [];

	ngOnInit() {
		this.route.paramMap.subscribe(params => {
			const slug = params.get('slug');
			if (slug) {
				this.careerJobsList = this.joblist.find(data => data.slug === slug);
			}
		});
		// Meta Title & skills
		this.titleService.setTitle("Work With RPA - Make Your Career Grow | Pro Web");
		this.metaTagService.updateTag(
			{ name: 'skills', content: 'Top Rated Web Design & App Development Agency with more than 11 years experience in building results driven custom web based solutions.' }
		);
		// Meta Title & skills

		this.http.get(this.blogUrl + 'countries').subscribe(async response => {
			let data: any = response;
			this.countries = data.response;
			// console.log("this.countries", this.countries)
		});

   		this.addBodyClass();

        /* Generate code according to resolution open here */
        if (window.screen.width < 768) {
        this.isMobile = true;
        this.isDesktop = false;
        }
        else{
        this.isMobile = false;
        this.isDesktop = true;
        }
        /* Generate code according to resolution close here */

   	    this.addBodyClass();

		this.careerForm = this.formBuilder.group({
			name: [],
			email: [],
			country_code: ['91'],
			phone_number: [],
			interested_in: [],
			linkedin_url: [],
			resume: [],
			filedata: []
		});
	}

	getFiles(event: any) {
		this.filedata = event.target.files;
		if(this.filedata.length) {
			this.filename = this.filedata[0].name;
		} else {
			this.filename = "";
		}
	}

	get f() { return this.careerForm.controls; }
	
	onSubmit(event: any) {
		this.isDisabled = true;
        this.submitted  = true;
		this.showLoader = true;
		const formData = new FormData(event.target);
		this.http.post(this.blogUrl + 'save_career_enquiry', formData).subscribe(data => {
			this.showLoader = false;
			let ClientsData: any = data;
			if (ClientsData.success == true) {
				this.alertService.clear();
				this.alertService.success(ClientsData.message);
				this.submitted = false;
				this.careerForm.reset();
				this.isDisabled = false;
				this.router.navigate(['/thankyou']);
			} else {
				this.alertService.clear();
				this.alertService.error(ClientsData.message);
				this.isDisabled = false;
			}
		});
	}

	telInputObject(obj: any) {
		obj.setCountry('in');
	}
	countryChange(country: any) {
		console.log(this.careerForm.controls);
		this.careerForm.controls.country_code.setValue(country.dialCode);
	}
	numberOnly(event: any): boolean {
		const charCode = (event.which) ? event.which : event.keyCode;
		if (charCode > 31 && (charCode < 48 || charCode > 57)) {
			return false;
		}
		return true;
	}
	selectjob(job: any,el: HTMLElement) {
		// this.careerForm.controls.interested_in=job;
		this.careerForm.controls.interested_in.setValue(job);
		el.scrollIntoView({behavior:"smooth"});
	}

	addBodyClass() {
		const bodyTag = document.body;
		bodyTag.classList.add('career-page');
	}

	joblist=[
		{
			title:"Marketing Manager",
			profile_id:"",
			experience:"Minimum 8 years",
			skills:"Critical Thinking, Knowledge of business environment, Analytical thinking, Investment Management, Digital Advertising, Content Marketing, Market Research",
			location:"Dubai",
			slug:"marketing-manager",
			job_description:"<p>We are on the lookout for an experienced Marketing Manager to join our team and take charge of our marketing strategies. As a Marketing Manager, you will be responsible for overseeing the planning and execution of marketing initiatives, ensuring alignment with business objectives. This role presents an exciting opportunity for a seasoned marketing professional to drive our brand's success and contribute to our continued growth.</p><b>Responsibilities:</b><p>Develop and execute comprehensive marketing strategies to meet business objectives. Analyze market trends and conduct in-depth market research. Oversee digital advertising campaigns and optimize for maximum impact. Collaborate with cross-functional teams to ensure consistent brand messaging. Utilize critical thinking to analyze data and make informed marketing decisions. Manage and optimize content for various marketing channels. Stay updated on industry trends and incorporate innovative marketing tactics. Implement and monitor investment management strategies for marketing budgets. Foster customer engagement through effective content marketing initiatives. Provide leadership in enhancing the overall customer experience.</p><b> Requirements:</b><p>Bachelor's degree in Marketing, Business, or a related field. Minimum of 8 years of experience in a marketing management role. Strong analytical skills and the ability to think critically about marketing challenges. In-depth knowledge of the business environment, market trends, and industry dynamics. Experience in digital advertising, with a focus on campaign optimization. Proven expertise in content marketing strategies and execution. Demonstrated ability to lead and collaborate with cross-functional teams. Excellent verbal communication and presentation skills.</p><b> Skillset:</b><p>Critical Thinking: Analyzing information and data. Interpreting information and data.</p><p>Verbal Communication: Oral Communication Presentations.</p><p>Knowledge of Business Environment: Market trends and Industry trends.</p><p>Analytical Thinking: Identifying cause and effect relationships. Gathering information and data.</p><p>Investment Management: Budget allocation and optimizing return on investment (ROI).</p><p>Digital Advertising: Campaign management, analytics, and optimization.</p><p>Content Marketing: Strategy development and execution across various channels.</p><p>Market Research: Conducting thorough market research to inform marketing strategies.</p>"
		},
		{
			title:"Customer Support Executive",
			profile_id:"",
			experience:"Minimum 3 years",
			skills:"Empathy, Communication, Problem-Solving, Multi-Channel Support, Patience, Technical Proficiency, Customer Relationship Management (CRM)",
			location:"Dubai",
			slug:"customer-support-executive",
			job_description:"<p>Job Description:</p><p>We are in search of a skilled Customer Support Executive to join our team and deliver exceptional service to our valued customers. As a Customer Support Executive, you will play a crucial role in ensuring customer satisfaction by addressing inquiries, resolving issues, and providing timely assistance. This is an exciting opportunity for a customer-focused professional to contribute to our commitment to delivering outstanding customer experiences.</p><b>Responsibilities:</b><p>Provide timely and effective customer support through various channels, including phone, email, and chat. Demonstrate empathy and patience in addressing customer concerns and inquiries. Troubleshoot and resolve customer issues with a focus on first-contact resolution. Collaborate with cross-functional teams to escalate and resolve complex issues. Utilize customer relationship management (CRM) tools to track and manage customer interactions. Stay updated on product knowledge and industry trends to provide accurate information to customers. Maintain a high level of professionalism and customer service etiquette in all interactions. Identify and communicate recurring issues to contribute to continuous improvement. Contribute to the development and improvement of customer support processes and procedures. Ensure customer satisfaction by exceeding service expectations. </p><b>Requirements:</b><p>Minimum of 3 years of experience in customer support or a related field. Excellent communication skills, both verbal and written. Empathetic and patient approach to customer interactions. Strong problem-solving skills with a focus on finding effective solutions. Technical proficiency to navigate customer support tools and systems. Familiarity with customer relationship management (CRM) software. Ability to handle multiple tasks and prioritize effectively. Previous experience in a multi-channel support environment is a plus. </p><b>Skillset:</b><p>Empathy: Understanding and relating to customer concerns.</p><p>Communication: Clear and effective verbal and written communication.</p><p>Problem-Solving: Analytical thinking and finding practical solutions.</p><p>Multi-Channel Support: Handling customer inquiries through various communication channels.</p><p>Patience: Remaining calm and composed in challenging situations.</p><p>Technical Proficiency: Ability to navigate and utilize support tools and systems.</p><p>Customer Relationship Management (CRM): Recording and managing customer interactions for effective support.</p><p>If you are passionate about delivering exceptional customer service and thrive in a dynamic and customer-centric environment, we invite you to apply for the position of Customer Support Executive. Join our team and be a key player in ensuring our customers receive the best support experience.</p>"
		}
    ]

  	// Team section open here
    teamTestimonials = [
		{
			img: "assets/img/team-reviews/Neeraj-Bhawsar.png",
			name: "Neeraj Bhawsar",
			designation: "Technical Team Lead",
			feedback:"I have been working with RPA Technologies for more than 3 years. It is a very great and career uplifting experience and I am sure that other people will also be able to repeat my experience. It's a growing organization with a number of big clients and a great platform to grow your career & learn new technologies specially for the freshers.",
		},      
		{
			img: "assets/img/team-reviews/Neelam-Manker.png",
			name: "Neelam Manker",
			designation: "SEO Analyst",
			feedback:"Good place to work! I have been working at RPA Technologies (more than a year). It is the best place for learning new technologies. I highly recommend!",
		},
		{
			img: "assets/img/team-reviews/Saurabh-Jain.png",
			name: "Saurabh Jain",
			designation: "Graphic Designer",
			feedback:"friendly environment",
		},
		{
			img: "assets/img/team-reviews/Appeaksha-Awatramani.png",
			name: "Appeaksha Awatramani",
			designation: "Web Tester",
			feedback:"Great workplace and a company with good business acumen and vision !",
		},
		{
			img: "assets/img/team-reviews/Jayshri-Gupta.png",
			name: "Jayshri Gupta",
			designation: "Marketing Content Writer",
			feedback:"The office ambience is great.",
		},
		{
			img: "assets/img/team-reviews/Anshul-Nema.png",
			name: "Anshul Nema",
			designation: "Digital Marketing Executive",
			feedback:"Good place to work! I have recently joined RPA Technologies as a digital marketing executive. Employees of RPA Technologies are talented and helpful. I highly recommend!",
		},
		{
			img: "assets/img/team-reviews/Ankita-Jain.png",
			name: "Ankita Jain",
			designation: "Sr. Marketing Executive",
			feedback:"I am working in this company full time for more than 3 years,having a good work experience.",
		},
		{
			img: "assets/img/team-reviews/Neelesh-Tiwari.png",
			name: "Neelesh Tiwari",
			designation: "Sr. PHP Developer",
			feedback:"Good company to work. I have enhanced my skills and worked on so many technologies.Team Lead is very good,i have learned many things from him.good place to learn new technologies and build career.",
		},
		{
			img: "assets/img/team-reviews/Shruti-Shrivastava.png",
			name: "Shruti Shrivastava",
			designation: "Content Writer",
			feedback:"RPA Technologies is the best company in India providing affordable web design & development solutions. The professional support that i have received frm them is really commendable!",
		},
		{
			img: "assets/img/team-reviews/Hitesh-Chaurasia.png",
			name: "Hitesh Chaurasia",
			designation: "Web Developer",
			feedback:"It's a great place to work, everyday you're going to learn something new which is going to help a lot in boosting up your skills. Beside that whole staff have very supportive and friendly nature.",
		},
		{
			img: "assets/img/team-reviews/Varsha-Suryawanshi.png",
			name: "Varsha Suryawanshi",
			designation: "Graphic Designer",
			feedback:"Excellent platform to initiate your career and enhance your skills.",
		},
		{
			img: "assets/img/team-reviews/Ankit-Richhariya.png",
			name: "Ankit Richhariya",
			designation: "Sr. PHP Developer",
			feedback:"I had a great time when I was working in Pro Web. I have enhanced my skills and worked on so many technologies. So it was good to work their.",
		},
		{
			img: "assets/img/team-reviews/Anamika-Sethi.png",
			name: "Anamika Sethi",
			designation: "Sr. SEO Executive",
			feedback:"My experience was very good with RPA Technologies, delivered what they promised, highly recommend.",
		},
		{
			img: "assets/img/team-reviews/Pranati-Khare.png",
			name: "Pranati Khare",
			designation: "UI/UX Designer Intern",
			feedback:"Quite good environment,seniors are very friendly and of helping nature,fortunate to be a part of RPA Technologies.",
		},
		{
			img: "assets/img/team-reviews/Gurpreet-Walia.png",
			name: "Gurpreet Walia",
			designation: "Business Analyst",
			feedback:"I have been working in RPA technologies from past 2 years and it ia great place to work. I have learnt a lot from this company",
		},
    ];

  	// Vacnacy block open here
    vacblocks = [
		{
			status: "apply-inactive",
			title: "Wordpress Developer",
			ctc: "1.3 to 2.3 Lacs",
			experience: "Minimum 1 Year",
			skills: "Wordpress, WooCommerce, PHP, Mysql, Jquery, Ajax",
		},
		{
			status: "apply-inactive",
			title: "UI/UX Designer",
			ctc: "1.5 to 2.5 Lac",
			experience: "Minimum 1-2 Year",
			skills: "Protoyping, UX Research, Adobe XD, Photoshop, Illustrator, Sketch, Invision Studio"
		},
		{
			status: "apply-inactive",
			title: "UI/Front-End Developer",
			ctc: "1.5 to 2.5 Lac",
			experience: "Minimum 1-2 Year",
			skills: "Angular, React, jQuery, JavaScript, CSS, SCSS, Git, Cross-Browser Development"
		},
		{
			status: "apply-inactive",
			title: "Content Writer",
			ctc: "1.5 to 2.0 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Excellent Writing Skills, Web Content, SEO Content and SMO content, UX Writing",
		},
		{
			status: "apply-inactive",
			title: "PHP Developer",
			ctc: "1.2 to 2.3 Lac",
			experience: "Minimum 1.5-2 Year",
			skills: "PHP7, Mysqli, Ajax, jQuery, Javascript framework, CMS, Laravel, Git",
		},
		{
			status: "apply-active",
			title: "Ecommerce Developer",
			ctc: "1.3 to 2.3 Lac",
			experience: "Minimum 1.5 - 2 Year",
			skills: "Opencart, Shopify, Prestashop, Magento, PHP7, Mysqli, Ajax, jQuery",
		},
		{
			status: "apply-inactive",
			title: "Graphic Designer",
			ctc: "1.0 to 2.0 Lac",
			experience: "Minimum 0 - 1 Year",
			skills: "Adobe Photoshop, Adobe Illustrator, CorelDraw, Adobe InDesign, Sketch",
		},
		{
			status: "apply-inactive",
			title: "Web/App Tester",
			ctc: "1.0 to 2.0 Lac",
			experience: "Minimum 1-1.5 Year",
			skills: "Manual Testing, Automation Testing, Knowledge about Ecommerce, SDLC knowledge",
		},
		{
			status: "apply-active",
			title: "Hybrid App Developer",
			ctc: "2.5 to 3.5 Lac",
			experience: "Minimum 1.5-2 Year",
			skills: "Ionic, React Native, Flutter, Angular, Node, SCSS, NPM, Git, Firebase, API Integration",
		},
		{
			status: "apply-inactive",
			title: "Business Development Executive",
			ctc: "1.5 to 2.5 Lac",
			experience: "Minimum  0-1  Year",
			skills: "Convincing and marketing skills, Idea of techniques for business growth, Technical proposal, Financial Proposal, Scope of work",
		},
		{
			status: "apply-active",
			title: "Customer Support Executive",
			ctc: "1.0 to 1.5 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Good Communication Skills, Cool-tempered, Understand customer requirements, Mail drafting, Computer efficiency",
		},
		{
			status: "apply-inactive",
			title: "SEO Executive ( Off Page )",
			ctc: "1.0 to 1.8 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Blogging, Planning & strategizing, Business listing, Keywords ranking, Audits, Back linking",
		},
		{
			status: "apply-inactive",
			title: "SEO Executive ( On page )",
			ctc: "1.0 to 1.8 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Technical SEO, Website audit, Semantic SEO, Goggle webmaster tools, Tracking website performance",
		},
		{
			status: "apply-inactive",
			title: "Google Adwords Executive",
			ctc: "1.0 to 1.8 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Analytical, Analyze current PPC campaigns, Statistical Analysis, Creating Google ads campaign, Analyzing websites performance",
		},
		{
			status: "apply-inactive",
			title: "Social Media Analyst",
			ctc: "1.0 to 1.8 Lac",
			experience: "Minimum 0-1 Year",
			skills: "Content Creating Skills, Social Media Strategy & Planning, Latest SMM Trends, Creative Mindset, Creating an engaging advertisement content, Creating Ad campaigns",
		},
		{
			status: "apply-active",
			title: "Web/App Developer Intern",
			ctc: "2k to 6k(Stipend)",
			experience: "Minimum 0-3 Month",
			skills: "Basic knowledge of any back-end & front-end framework",
		},
		{
			status: "apply-inactive",
			title: "UI  Developer Intern",
			ctc: "2k to 6k(Stipend)",
			experience: "Minimum 0-3 Month",
			skills: "Basic knowledge of HTML , CSS ,JavaScript or any front-end framework",
		},
		{
			status: "apply-inactive",
			title: "Digital Marketing Intern",
			ctc: "2k to 6k(Stipend)",
			experience: "Minimum 0-3 Month",
			skills: "Basic knowledge of SEO(Off-Page & On-Page), SMO, PPC",
		}
    ];
  	// Vacnacy block close here

	
}